export class LegalApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** What the signed-in rider/driver must accept (their account's country, their realm's audience). */
    status() {
        return this.client.request({ method: 'GET', path: '/v1/legal/status', auth: true });
    }
    /** Record the acceptance of a PUBLISHED version (a replay answers the first acceptance). */
    accept(documentId) {
        return this.client.request({ method: 'POST', path: '/v1/legal/acceptances', body: { documentId }, auth: true });
    }
    /** The version in force of a text (public — no session): `LEGAL_DOCUMENT_NOT_PUBLISHED` when none is. */
    document(country, audience, kind) {
        return this.client.request({ method: 'GET', path: `/v1/public/legal-documents/${encodeURIComponent(country)}/${audience}/${kind}`, auth: false });
    }
}
export class LegalAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    list(country) {
        return this.client.request({ method: 'GET', path: `/v1/admin/legal-documents?country=${encodeURIComponent(country)}`, auth: true });
    }
    createDraft(input) {
        return this.client.request({ method: 'POST', path: '/v1/admin/legal-documents', body: input, auth: true });
    }
    /** Edit a DRAFT's words (the editor becomes its drafter — so they cannot publish it). */
    editDraft(documentId, edit) {
        return this.client.request({ method: 'PUT', path: `/v1/admin/legal-documents/${encodeURIComponent(documentId)}`, body: edit, auth: true });
    }
    /**
     * Publish a DRAFT — a DIFFERENT operator than its drafter (`LEGAL_FOUR_EYES_SELF_PUBLISH`), naming the content hash of the
     * words they reviewed (`LEGAL_DOCUMENT_CHANGED` when the draft was edited since — review W8S-06).
     */
    publish(documentId, reviewedContentHash) {
        return this.client.request({ method: 'POST', path: `/v1/admin/legal-documents/${encodeURIComponent(documentId)}/publish`, body: { contentHash: reviewedContentHash }, auth: true });
    }
}
//# sourceMappingURL=legal.js.map